export const FeaturesList = [
  {
    id: "",
    label: "Popup Shop",
    name: "popupShop",
    status: "",
  },
  {
    id: "",
    label: "Line Ups",
    name: "lineUps",
    status: "",
  },
  {
    id: "",
    label: "Banners",
    name: "banners",
    status: "",
  },
  {
    id: "",
    label: "Videos",
    name: "videos",
    status: "",
  },
  {
    id: "",
    label: "News",
    name: "news",
    status: "",
  },
  {
    id: "",
    label: "Merchandises",
    name: "merchandises",
    status: "",
  },
  {
    id: "",
    label: "Galleries",
    name: "galleries",
    status: "",
  },
  {
    id: "",
    label: "Menus",
    name: "menus",
    status: "",
  },
  {
    id: "",
    label: "Reservations",
    name: "reservations",
    status: "",
  },
  {
    id: "",
    label: "Past Collaborations",
    name: "pastCollaborations",
    status: "",
  },
  {
    id: "",
    label: "Contact US",
    name: "contactUs",
    status: "",
  },
  {
    id: "",
    label: "Social Media",
    name: "socialMedia",
    status: "",
  },
  {
    id: "",
    label: "Login",
    name: "login",
    status: "",
  },
  {
    id: "",
    label: "Sign Up",
    name: "signup",
    status: "",
  },
  {
    id: "",
    label: "Logout",
    name: "logout",
    status: "",
  },
];
